import ActionTypes from "./ActionTypes";

const MyAdvertisement = (payload) => {
  return {
    type: ActionTypes.GET_MY_ADVERTISEMENTS,
    payload,
  };
};
const deleteAdvertisement = (payload) => {
  return {
    type: ActionTypes.DELETE_ADVERTISEMENT,
    payload,
  };
};
export { MyAdvertisement, deleteAdvertisement };
